export const BUILD_PROFILE = import.meta.env.VITE_BUILD_PROFILE;
export const BASE_API = import.meta.env.VITE_BASE_API;
export const MODULES_API = import.meta.env.VITE_MODULES_API_URL;
export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const CONFIG_LABEL = import.meta.env.VITE_CONFIG_LABEL;
export const APP_VERSION = import.meta.env.VITE_VERSION;
